<template>
  <b-field
    :label="label"
    :type="(phoneErrorMessage() ? 'is-danger': '')"
    :message="phoneErrorMessage()"
  >
    <input
      ref="input"
      :placeholder="placeholder"
      :name="name"
      type="tel"
      :disabled="disabled"
      class="input"
      :class="{'is-danger': hasError(), 'is-disabled': disabled}"
      @change="onChange"
      @keyup="onChange"
      @countrychange="onChange"
    >
  </b-field>
</template>

<script>
import InputBase from "./InputBase";
import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/css/intlTelInput.css";

export default {
  extends: InputBase,
  props: {
    value: {
      required: true,
      validator () {
        return true;
      }
    },
    disabled: {
      type: Boolean
    },
  },
  data () {
    return {
      error: false
    };
  },
  mounted () {
    this.iti = intlTelInput(this.$refs.input, {
      initialCountry: "ca",
      separateDialCode: true,
      preferredCountries: ["ca"],
      autoPlaceholder: "polite",
      countryOrder: ["CA"],
      onlyCountries: ["CA", "US"],
      validationNumberTypes: ["MOBILE"],
      loadUtils: () => import("intl-tel-input/utils"),
    });
    if (this.value) {
      this.iti.setNumber(this.value);
    }
  },
  methods: {
    onChange() {
      const fullNumber = this.iti._getFullNumber().replace(/\D/g,"");

      if (fullNumber == "" || fullNumber == null) {
        this.inputListener("");
        this.error = false;
      } else if (this.iti.isValidNumber()) {
        this.inputListener(this.iti.getNumber());
        this.error = false;
      } else {
        this.inputListener(fullNumber);
        this.error = true;
      }
    },
    phoneErrorMessage () {

      if (this.error) {
        return this.$t("invalid_phone_number");
      }

      if (this.errorMessage()) {
        return this.errorMessage();
      }

      return null;
    }
  }
};
</script>

<style>
.iti__flag {background-image: url("/img/icons/intl-tel-input/flags.png");}

</style>
